import { RouterParamType } from "@/model/navModel";
import React, { FC, useState } from "react";
import { FormVal } from './FormVal';
import { Steps } from "./Steps";


export const LogisticsProcess: FC<RouterParamType> = (detailsInfo) => {

    return (
        <>
            <Steps {...detailsInfo} />
            <FormVal {...detailsInfo} />
        </>
    )
}